export const GROUP_ACTION_PERSIST = "GROUP_PERSIST";
export const GROUP_ACTION_CLEAR = "GROUP_CLEAR";
